import { Footer } from '../components/footer/footer';
import { Scroll } from '../components/scroll/scroll';
import { Header } from '../components/header/header';
import { ContentIndex } from '../components/content-index';
import { Gallery } from '../components/gallery/gallery';
import './projects.scss';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';

function DesignSystemArchitecture() {
  const { translations } = useI18n();
  const d = translations.plurallPage.diagrams.architecture;
  return (
    <div className="case-diagram" aria-label={d.ariaLabel}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 980 820" width="100%"  fill="none"><rect width="210" height="694" x="56" y="56" fill="var(--fill-bottom)" rx="16"></rect><path fill="var(--fill-low)" d="M687.232 201.308a2.501 2.501 0 0 0 3.536 0l15.91-15.91a2.501 2.501 0 0 0-3.536-3.536L689 196.004l-14.142-14.142a2.501 2.501 0 0 0-3.536 3.536l15.91 15.91ZM689 143.68h-2.5v55.86h5v-55.86H689ZM687.232 352.928a2.501 2.501 0 0 0 3.536 0l15.91-15.91a2.501 2.501 0 0 0-3.536-3.536L689 347.625l-14.142-14.143a2.501 2.501 0 0 0-3.536 3.536l15.91 15.91ZM689 295.3h-2.5v55.86h5V295.3H689ZM687.232 504.548a2.501 2.501 0 0 0 3.536 0l15.91-15.91a2.501 2.501 0 0 0-3.536-3.536L689 499.244l-14.142-14.142a2.501 2.501 0 0 0-3.536 3.536l15.91 15.91ZM689 446.92h-2.5v55.86h5v-55.86H689ZM687.232 656.168a2.501 2.501 0 0 0 3.536 0l15.91-15.91a2.501 2.501 0 0 0-3.536-3.536L689 650.865l-14.142-14.143a2.501 2.501 0 0 0-3.536 3.536l15.91 15.91ZM689 598.54h-2.5v55.86h5v-55.86H689Z"></path><path fill="var(--fill-high)" fillOpacity="1" d="M928.4 56.03H449.6c-6.959 0-12.6 7.163-12.6 16v56c0 8.836 5.641 16 12.6 16h478.8c6.959 0 12.6-7.164 12.6-16v-56c0-8.837-5.641-16-12.6-16Z"></path><text xmlSpace="preserve" fill="var(--fill-lowest)" fillOpacity="1" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em"><tspan x="554.135" y="107.512">EXPERIÊNCIAS DE PRODUTO</tspan></text><path fill="var(--fill-high)" fillOpacity="1" d="M928.4 208.03H449.6c-6.959 0-12.6 7.082-12.6 15.818v55.364c0 8.736 5.641 15.818 12.6 15.818h478.8c6.959 0 12.6-7.082 12.6-15.818v-55.364c0-8.736-5.641-15.818-12.6-15.818Z"></path><text xmlSpace="preserve" fill="var(--fill-lowest)" fillOpacity="1" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em"><tspan x="629.801" y="259.132">PADRÕES</tspan></text><path fill="var(--fill-high)" fillOpacity="1" d="M928.4 359.03H449.6c-6.959 0-12.6 7.163-12.6 16v56c0 8.836 5.641 16 12.6 16h478.8c6.959 0 12.6-7.164 12.6-16v-56c0-8.837-5.641-16-12.6-16Z"></path><text xmlSpace="preserve" fill="var(--fill-lowest)" fillOpacity="1" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em"><tspan x="607.841" y="410.752">COMPONENTES</tspan></text><path fill="var(--fill-high)" fillOpacity="1" d="M928.4 511.03H449.6c-6.959 0-12.6 7.163-12.6 16v56c0 8.836 5.641 16 12.6 16h478.8c6.959 0 12.6-7.164 12.6-16v-56c0-8.837-5.641-16-12.6-16Z"></path><text xmlSpace="preserve" fill="var(--fill-lowest)" fillOpacity="1" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em"><tspan x="642.997" y="562.372">TOKENS</tspan></text><path fill="var(--fill-high)" fillOpacity="1" d="M928.4 662.03H449.6c-6.959 0-12.6 7.163-12.6 16v56c0 8.836 5.641 16 12.6 16h478.8c6.959 0 12.6-7.164 12.6-16v-56c0-8.837-5.641-16-12.6-16Z"></path><text xmlSpace="preserve" fill="var(--fill-lowest)" fillOpacity="1" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em"><tspan x="607.936" y="713.992">FOUNDATIONS</tspan></text><text xmlSpace="preserve" fill="var(--fill-high)" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em"><tspan x="80.357" y="371.5">GOVERNANÇA</tspan></text><text xmlSpace="preserve" fill="var(--fill-high)" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em"><tspan x="152.206" y="411.4">+</tspan></text><text xmlSpace="preserve" fill="var(--fill-high)" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em"><tspan x="100.235" y="451.3">FEEDBACK</tspan></text><path fill="var(--fill-low)" d="M294.232 100.232a2.501 2.501 0 0 0 0 3.536l15.91 15.91a2.501 2.501 0 0 0 3.536-3.536L299.536 102l14.142-14.142a2.5 2.5 0 0 0-3.536-3.536l-15.91 15.91Zm115.536 3.536a2.501 2.501 0 0 0 0-3.536l-15.91-15.91a2.5 2.5 0 0 0-3.536 3.536L404.464 102l-14.142 14.142a2.501 2.501 0 0 0 3.536 3.536l15.91-15.91ZM296 102v2.5h112v-5H296v2.5ZM294.232 250.232a2.501 2.501 0 0 0 0 3.536l15.91 15.91a2.501 2.501 0 0 0 3.536-3.536L299.536 252l14.142-14.142a2.501 2.501 0 0 0-3.536-3.536l-15.91 15.91Zm115.536 3.536a2.501 2.501 0 0 0 0-3.536l-15.91-15.91a2.501 2.501 0 0 0-3.536 3.536L404.464 252l-14.142 14.142a2.501 2.501 0 0 0 3.536 3.536l15.91-15.91ZM296 252v2.5h112v-5H296v2.5ZM294.232 400.232a2.501 2.501 0 0 0 0 3.536l15.91 15.91a2.501 2.501 0 0 0 3.536-3.536L299.536 402l14.142-14.142a2.501 2.501 0 0 0-3.536-3.536l-15.91 15.91Zm115.536 3.536a2.501 2.501 0 0 0 0-3.536l-15.91-15.91a2.501 2.501 0 0 0-3.536 3.536L404.464 402l-14.142 14.142a2.501 2.501 0 0 0 3.536 3.536l15.91-15.91ZM296 402v2.5h112v-5H296v2.5ZM294.232 550.232a2.501 2.501 0 0 0 0 3.536l15.91 15.91a2.501 2.501 0 0 0 3.536-3.536L299.536 552l14.142-14.142a2.501 2.501 0 0 0-3.536-3.536l-15.91 15.91Zm115.536 3.536a2.501 2.501 0 0 0 0-3.536l-15.91-15.91a2.501 2.501 0 0 0-3.536 3.536L404.464 552l-14.142 14.142a2.501 2.501 0 0 0 3.536 3.536l15.91-15.91ZM296 552v2.5h112v-5H296v2.5ZM294.232 700.232a2.501 2.501 0 0 0 0 3.536l15.91 15.91a2.501 2.501 0 0 0 3.536-3.536L299.536 702l14.142-14.142a2.501 2.501 0 0 0-3.536-3.536l-15.91 15.91Zm115.536 3.536a2.501 2.501 0 0 0 0-3.536l-15.91-15.91a2.501 2.501 0 0 0-3.536 3.536L404.464 702l-14.142 14.142a2.501 2.501 0 0 0 3.536 3.536l15.91-15.91ZM296 702v2.5h112v-5H296v2.5Z"></path></svg></div>
  );
}

function AutomationFlow() {
  const { translations } = useI18n();
  const d = translations.plurallPage.diagrams.automationFlow;
  return (
    <div className="case-diagram" aria-label={d.ariaLabel}>
    <svg 
      viewBox="0 0 980 425" 
      width="100%" 
       
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="365" y="17" width="249" height="391" rx="16" fill="var(--fill-bottom)" />
      
      <text fill="var(--fill-highest)" fillOpacity={1} xmlSpace="preserve" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em" style={{ whiteSpace: 'pre' }}>
        <tspan x="394" y="145.5">FIGMA PLUGIN</tspan>
      </text>
      
      <text fill="var(--fill-highest)" fillOpacity={1} xmlSpace="preserve" fontFamily="Inter" fontSize="18" fontWeight="600" letterSpacing="0em" style={{ whiteSpace: 'pre' }}>
        <tspan x="394" y="182.197">Usa componentes do DS</tspan>
        <tspan x="394" y="239.697">Configura Auto Layout</tspan>
        <tspan x="394" y="297.197">Organiza o canvas</tspan>
      </text>
      
      <path d="M359.628 112.768C360.604 111.791 360.604 110.209 359.628 109.232L343.718 93.3223C342.742 92.346 341.159 92.346 340.182 93.3223C339.206 94.2986 339.206 95.8816 340.182 96.8579L354.324 111L340.182 125.142C339.206 126.118 339.206 127.701 340.182 128.678C341.159 129.654 342.742 129.654 343.718 128.678L359.628 112.768ZM302 111L302 113.5L357.86 113.5L357.86 111L357.86 108.5L302 108.5L302 111Z" fill="var(--fill-low)" />
      <path d="M671.628 212.768C672.604 211.791 672.604 210.209 671.628 209.232L655.718 193.322C654.742 192.346 653.159 192.346 652.182 193.322C651.206 194.299 651.206 195.882 652.182 196.858L666.324 211L652.182 225.142C651.206 226.118 651.206 227.701 652.182 228.678C653.159 229.654 654.742 229.654 655.718 228.678L671.628 212.768ZM614 211L614 213.5L669.86 213.5L669.86 211L669.86 208.5L614 208.5L614 211Z" fill="var(--fill-low)" />
      <path d="M359.628 329.768C360.604 328.791 360.604 327.209 359.628 326.232L343.718 310.322C342.742 309.346 341.159 309.346 340.182 310.322C339.206 311.299 339.206 312.882 340.182 313.858L354.324 328L340.182 342.142C339.206 343.118 339.206 344.701 340.182 345.678C341.159 346.654 342.742 346.654 343.718 345.678L359.628 329.768ZM302 328L302 330.5L357.86 330.5L357.86 328L357.86 325.5L302 325.5L302 328Z" fill="var(--fill-low)" />
      
      <rect x="54" y="17" width="248" height="218" rx="16" fill="var(--fill-highest)" fillOpacity={1} />
      <rect x="56" y="19" width="244" height="214" rx="14" />
      
      <text fill="var(--fill-bottom)" fillOpacity={1} xmlSpace="preserve" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em" style={{ whiteSpace: 'pre' }}>
        <tspan x="90" y="82.5">ENTRADA</tspan>
        <tspan x="90" y="109.5">(DESIGNER)</tspan>
      </text>
      
      <text fill="var(--fill-bottom)" fillOpacity={1} xmlSpace="preserve" fontFamily="Inter" fontSize="18" fontWeight="600" letterSpacing="0em" style={{ whiteSpace: 'pre' }}>
        <tspan x="90" y="149.545">Fluxo / Contexto</tspan>
        <tspan x="90" y="181.545">Breakpoint</tspan>
      </text>
      
      <rect x="678" y="117" width="248" height="191" rx="16" fill="var(--fill-highest)" fillOpacity={1} />
      <rect x="680" y="119" width="244" height="187" rx="14" />
      
      <text fill="var(--fill-bottom)" fillOpacity={1} xmlSpace="preserve" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em" style={{ whiteSpace: 'pre' }}>
        <tspan x="714" y="182.5">SAÍDA</tspan>
      </text>
      
      <text fill="var(--fill-bottom)" fillOpacity={1} xmlSpace="preserve" fontFamily="Inter" fontSize="18" fontWeight="600" letterSpacing="0em" style={{ whiteSpace: 'pre' }}>
        <tspan x="714" y="222.545">UI editável</tspan>
        <tspan x="714" y="254.545">Alinhada ao sistema</tspan>
      </text>
      
      <rect x="54" y="249" width="248" height="159" rx="16" fill="var(--fill-highest)" fillOpacity={1} />
      <rect x="56" y="251" width="244" height="155" rx="14" />
      
      <text fill="var(--fill-bottom)" fillOpacity={1} xmlSpace="preserve" fontFamily="Inter" fontSize="22" fontWeight="900" letterSpacing="0em" style={{ whiteSpace: 'pre' }}>
        <tspan x="90" y="314.5">SYSTEM RULES</tspan>
      </text>
      
      <text fill="var(--fill-bottom)" fillOpacity={1} xmlSpace="preserve" fontFamily="Inter" fontSize="18" fontWeight="600" letterSpacing="0em" style={{ whiteSpace: 'pre' }}>
        <tspan x="90" y="354.545">Tokens &amp; regras</tspan>
      </text>
    </svg>
    </div>
  );
}

function DesignCodeFlow() {
  const { translations } = useI18n();
  const d = translations.plurallPage.diagrams.designCode;
  return (
    <div className="case-diagram" aria-label={d.title}>
      <svg
        viewBox="0 0 900 350"
        role="img"
        aria-labelledby="design-code-title design-code-description"
      >
        <title id="design-code-title">
          {d.title}
        </title>

        <desc id="design-code-description">
          {d.description}
        </desc>

        <defs>
          <marker
            id="design-code-arrow"
            markerWidth="10"
            markerHeight="10"
            refX="8"
            refY="3"
            orient="auto"
          >
            <path d="M0,0 L0,6 L9,3 z" />
          </marker>
        </defs>

        <rect
          x="50"
          y="60"
          width="250"
          height="210"
          rx="14"
          className="diagram-node"
        />

        <text
          x="175"
          y="100"
          textAnchor="middle"
          className="diagram-label"
        >
          {d.design}
        </text>

        {d.designItems.map((item, index) => (
          <text
            key={`design-${item}`}
            x="175"
            y={145 + index * 30}
            textAnchor="middle"
            className="diagram-label diagram-label--small"
          >
            {item}
          </text>
        ))}

        <rect
          x="600"
          y="60"
          width="250"
          height="210"
          rx="14"
          className="diagram-node"
        />

        <text
          x="725"
          y="100"
          textAnchor="middle"
          className="diagram-label"
        >
          {d.engineering}
        </text>

        {d.engineeringItems.map((item, index) => (
          <text
            key={`engineering-${item}`}
            x="725"
            y={145 + index * 30}
            textAnchor="middle"
            className="diagram-label diagram-label--small"
          >
            {item}
          </text>
        ))}

        <line
          x1="300"
          y1="130"
          x2="600"
          y2="130"
          className="diagram-line"
          markerEnd="url(#design-code-arrow)"
        />

        <line
          x1="600"
          y1="200"
          x2="300"
          y2="200"
          className="diagram-line"
          markerEnd="url(#design-code-arrow)"
        />

        <text
          x="450"
          y="117"
          textAnchor="middle"
          className="diagram-label diagram-label--small"
        >
          {d.sharedSystem}
        </text>

        <text
          x="450"
          y="188"
          textAnchor="middle"
          className="diagram-label diagram-label--small"
        >
          {d.parity}
        </text>
      </svg>
    </div>
  );
}

function GovernanceFlow() {
  const { translations } = useI18n();
  const d = translations.plurallPage.diagrams.governanceLoop;
  return (
    <div className="case-diagram" aria-label={d.title}>
      <svg
        viewBox="0 0 900 500"
        role="img"
        aria-labelledby="governance-title governance-description"
      >
        <title id="governance-title">
          {d.title}
        </title>

        <desc id="governance-description">
          {d.description}
        </desc>

        <defs>
          <marker
            id="governance-arrow"
            markerWidth="10"
            markerHeight="10"
            refX="8"
            refY="3"
            orient="auto"
          >
            <path d="M0,0 L0,6 L9,3 z" />
          </marker>
        </defs>

        <circle
          cx="450"
          cy="250"
          r="95"
          className="diagram-circle"
        />

        <text
          x="450"
          y="242"
          textAnchor="middle"
          className="diagram-label"
        >
          {d.designSystemTop}
        </text>

        <text
          x="450"
          y="268"
          textAnchor="middle"
          className="diagram-label"
        >
          {d.designSystemBottom}
        </text>

        <rect
          x="355"
          y="25"
          width="190"
          height="70"
          rx="12"
          className="diagram-node"
        />

        <text
          x="450"
          y="67"
          textAnchor="middle"
          className="diagram-label"
        >
          {d.usageData}
        </text>

        <rect
          x="690"
          y="215"
          width="170"
          height="70"
          rx="12"
          className="diagram-node"
        />

        <text
          x="775"
          y="257"
          textAnchor="middle"
          className="diagram-label"
        >
          {d.governance}
        </text>

        <rect
          x="355"
          y="405"
          width="190"
          height="70"
          rx="12"
          className="diagram-node"
        />

        <text
          x="450"
          y="447"
          textAnchor="middle"
          className="diagram-label"
        >
          {d.evolution}
        </text>

        <rect
          x="40"
          y="215"
          width="170"
          height="70"
          rx="12"
          className="diagram-node"
        />

        <text
          x="125"
          y="257"
          textAnchor="middle"
          className="diagram-label"
        >
          {d.productTeams}
        </text>

        <line
          x1="450"
          y1="95"
          x2="450"
          y2="150"
          className="diagram-line"
          markerEnd="url(#governance-arrow)"
        />

        <line
          x1="545"
          y1="250"
          x2="690"
          y2="250"
          className="diagram-line"
          markerEnd="url(#governance-arrow)"
        />

        <line
          x1="450"
          y1="345"
          x2="450"
          y2="405"
          className="diagram-line"
          markerEnd="url(#governance-arrow)"
        />

        <line
          x1="355"
          y1="250"
          x2="210"
          y2="250"
          className="diagram-line"
          markerEnd="url(#governance-arrow)"
        />
      </svg>
    </div>
  );
}

function CaseSection({
  eyebrow,
  title,
  children,
}: {
  eyebrow: string;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className="project-case project-case--section">
      <article className="project-case__intro">
        <span className="tag">{eyebrow}</span>
        <div className='h2'>{title}</div>
      </article>

      <article className="project-case__details">
        {children}
      </article>
    </section>
  );
}

function MetaGrid() {
  const { translations } = useI18n();
  const meta = translations.plurallPage.meta;

  const renderItems = (items: string[]) =>
    items.map((item, index) => (
      <span key={item}>
        {item}
        {index < items.length - 1 && <br />}
      </span>
    ));

  return (
    <div className="case-meta">
      <div className="case-meta__item">
        <span>{meta.rolesLabel}</span>
        <strong>{renderItems(meta.rolesItems)}</strong>
      </div>

      <div className="case-meta__item">
        <span>{meta.companiesLabel}</span>
        <strong>{renderItems(meta.companiesItems)}</strong>
      </div>

      <div className="case-meta__item">
        <span>{meta.scopesLabel}</span>
        <strong>{renderItems(meta.scopesItems)}</strong>
      </div>

      <div className="case-meta__item">
        <span>{meta.environmentsLabel}</span>
        <strong>{renderItems(meta.environmentsItems)}</strong>
      </div>
    </div>
  );
}

function PlurallCase() {
  const { translations } = useI18n();
  const t = translations.plurallPage;
  return (
    <>
      <Header
        title={t.headerTitle}
        breadcrumbs={[
          { label: 'GAraujo', href: '/' },
          { label: translations.nav.projects, href: '/projects' },
          { label: t.headerTitle, href: '/projects/plurall' },
        ]}
      />
      <ContentIndex />

      <div className="content project-case-page">
        <section className="case-hero">
          <span className="tag">
            {t.heroTag}
          </span>
          <h1>
            {t.heroTitle}
          </h1>
          <p className="case-hero__lead">
            {t.heroLead}
          </p>
          <div className='case-author'>{t.caseAuthorBy} <Link to="https://www.linkedin.com/in/guilhermeasouza">Guilherme Araújo</Link></div>
          <MetaGrid />
        </section>

        <Gallery
          images={[
            { src: '/img/projects/plurall/plurall-screens-01.png', alt: t.gallery.screensAlt1 },
            { src: '/img/projects/plurall/plurall-screens-02.png', alt: t.gallery.screensAlt2 },
          ]}
        />

        <hr />

        <CaseSection
          eyebrow={t.origin.eyebrow}
          title={t.origin.title}
        >
          <p>
            {t.origin.p1}
          </p>
          <p>
            {t.origin.p2}
          </p>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.whiteLabel.eyebrow}
          title={t.whiteLabel.title}
        >
          <p>
            {t.whiteLabel.p1}
          </p>
          <p>
            {t.whiteLabel.p2}
          </p>
          <p>
            {t.whiteLabel.note}
          </p>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.platformShift.eyebrow}
          title={t.platformShift.title}
        >
          <p>
            {t.platformShift.p1}
          </p>
          <p>
            {t.platformShift.p2}
          </p>
          <p>
            {t.platformShift.p3}
          </p>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.fragmentation.eyebrow}
          title={t.fragmentation.title}
        >
          <p>
            {t.fragmentation.p1}
          </p>
          <p>
            {t.fragmentation.p2}
          </p>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.eloSystem.eyebrow}
          title={t.eloSystem.title}
        >
          <p>
            {t.eloSystem.p1}
          </p>
          <p>
            {t.eloSystem.p2}
          </p>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.libraryToSystem.eyebrow}
          title={t.libraryToSystem.title}
        >
          <p>
            {t.libraryToSystem.p1}
          </p>
        </CaseSection>

        <DesignSystemArchitecture />

        <section className="case-layer-grid">
          <div className="case-layer">
            <span>01</span>
            <h3>{t.layers.foundations.name}</h3>
            <p>
              {t.layers.foundations.description}
            </p>
          </div>
          <div className="case-layer">
            <span>02</span>
            <h3>{t.layers.tokens.name}</h3>
            <p>
              {t.layers.tokens.description}
            </p>
          </div>
          <div className="case-layer">
            <span>03</span>
            <h3>{t.layers.components.name}</h3>
            <p>
              {t.layers.components.description}
            </p>
          </div>
          <div className="case-layer">
            <span>04</span>
            <h3>{t.layers.patterns.name}</h3>
            <p>
              {t.layers.patterns.description}
            </p>
          </div>
          <div className="case-layer">
            <span>05</span>
            <h3>{t.layers.experiences.name}</h3>
            <p>
              {t.layers.experiences.description}
            </p>
          </div>
          <div className="case-layer">
            <span>06</span>
            <h3>{t.layers.governance.name}</h3>
            <p>
              {t.layers.governance.description}
            </p>
          </div>
        </section>

        <hr />

        <CaseSection
          eyebrow={t.designPrinciple.eyebrow}
          title={t.designPrinciple.title}
        >
          <p>
            {t.designPrinciple.p1}
          </p>
          <p>
            {t.designPrinciple.p2}
          </p>
          <p className="case-highlight">
            {t.designPrinciple.highlight}
          </p>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.designOps.eyebrow}
          title={t.designOps.title}
        >
          <p>
            {t.designOps.p1}
          </p>
          <p>
            {t.designOps.p2}
          </p>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.automation.eyebrow}
          title={t.automation.title}
        >
          <p>
            {t.automation.p1}
          </p>
        </CaseSection>

        <AutomationFlow />

        <Gallery
          images={[
            { src: '/img/projects/plurall/plurall-figma-plugin-01.png', alt: t.gallery.eloCopilotPluginAlt },
            { src: '/img/projects/plurall/plurall-figma-plugin-02.png', alt: t.gallery.eloCopilotGenerationAlt },
          ]}
        />

        <hr />

        <CaseSection
          eyebrow={t.iconography.eyebrow}
          title={t.iconography.title}
        >
          <p>
            {t.iconography.p1}
          </p>
        </CaseSection>

        <Gallery
          images={[
            { src: '/img/projects/plurall/plurall-screens-03.png', alt: t.gallery.eloIconsPluginAlt },
          ]}
        />

        <hr />

        <CaseSection
          eyebrow={t.designEngineering.eyebrow}
          title={t.designEngineering.title}
        >
          <p>
            {t.designEngineering.p1}
          </p>
        </CaseSection>

        {/* <DesignCodeFlow /> */}

        <hr />

        <CaseSection
          eyebrow={t.observability.eyebrow}
          title={t.observability.title}
        >
          <p>
            {t.observability.p1}
          </p>
        </CaseSection>

        {/* <GovernanceFlow /> */}

        <hr />

        <CaseSection
          eyebrow={t.outcome.eyebrow}
          title={t.outcome.title}
        >
          <p>
            {t.outcome.p1}
          </p>
          <p>
            {t.outcome.p2}
          </p>
          <div className="case-outcomes">
            <div className="case-outcome">
              <strong>{t.outcomes.foundations.name}</strong>
              <span>{t.outcomes.foundations.description}</span>
            </div>
            <div className="case-outcome">
              <strong>{t.outcomes.tokens.name}</strong>
              <span>{t.outcomes.tokens.description}</span>
            </div>
            <div className="case-outcome">
              <strong>{t.outcomes.componentsPatterns.name}</strong>
              <span>{t.outcomes.componentsPatterns.description}</span>
            </div>
            <div className="case-outcome">
              <strong>{t.outcomes.governance.name}</strong>
              <span>{t.outcomes.governance.description}</span>
            </div>
            <div className="case-outcome">
              <strong>{t.outcomes.automation.name}</strong>
              <span>{t.outcomes.automation.description}</span>
            </div>
            <div className="case-outcome">
              <strong>{t.outcomes.observability.name}</strong>
              <span>{t.outcomes.observability.description}</span>
            </div>
          </div>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.recognition.eyebrow}
          title={t.recognition.title}
        >
          <p>
            {t.recognition.p1}
          </p>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.impact.eyebrow}
          title={t.impact.title}
        >
          <p>
            {t.impact.p1}
          </p>
          <p className="case-highlight">
            {t.impact.highlight}
          </p>
        </CaseSection>

        <hr />

        <CaseSection
          eyebrow={t.learning.eyebrow}
          title={t.learning.title}
        >
          <p>
            {t.learning.p1}
          </p>
          <p className="case-question">
            {t.learning.question}
          </p>
          <p>
            {t.learning.p2}
          </p>
        </CaseSection>

        <section className="case-closing">
          <span className="tag">{t.closing.tag}</span>
          <h2>
            {t.closing.title}
          </h2>
          <p>
            {t.closing.p1}
          </p>
        </section>
      </div>
    </>
  );
}

export default function PlurallProject() {
  return (
    <Scroll>
      <main className="page">
        <PlurallCase />
      </main>
    </Scroll>
  );
}
